export default __webpack_public_path__ + "static/media/8.776c37ec.png";